<template>
  <PageContainer>
    <el-row class="auth">
      <el-col :xs="24" :sm="24" :md="{offset: 2, span: 10}">
        <img :src="WelcomeImage">
      </el-col>
      <el-col :xs="24" :sm="24" :md="{span: 10}">
        <div class="auth__tabs">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            class="auth__tab"
            :class="activeClass(tab.key)"
            @click="handleChangeTab(tab.key)"
          >{{ tab.text }}</button>
        </div>
        <el-form
          v-if="currentTab === 'login'"
          key="login"
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          @submit.native.prevent
        >
          <div class="form-item">
            <div class="form-item__icon">
              <img :src="AccountImage">
            </div>
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" placeholder="請輸入帳號" />
            </el-form-item>
          </div>
          <div class="form-item">
            <div class="form-item__icon">
              <img :src="PasswordImage">
            </div>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                placeholder="請輸入密碼"
                text="password"
                show-password
              />
            </el-form-item>
          </div>
          <el-row type="flex" justify="end">
            <el-button native-type="submit" @click="handleLogin">
              送出
            </el-button>
          </el-row>
        </el-form>
        <el-form
          v-if="currentTab === 'register'"
          key="register"
          ref="registerForm"
          :model="registerForm"
          :rules="registerRules"
          @submit.native.prevent
        >
          <div class="form-item">
            <el-form-item prop="account">
              <el-input v-model="registerForm.account" placeholder="請輸入帳號" />
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item prop="registerPassword">
              <el-input v-model="registerForm.registerPassword" show-password placeholder="請輸入密碼" />
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item prop="repeatPassword">
              <el-input v-model="registerForm.repeatPassword" show-password placeholder="請確認密碼" />
            </el-form-item>
          </div>
          <el-row>
            <el-col :span="12">
              <div class="form-item">
                <el-form-item>
                  <el-select v-model="registerForm.accountType" @change="handleReValidate">
                    <el-option
                      v-for="item in accountTypeSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="form-item">
                <p>性別</p>
                <el-form-item prop="sex">
                  <el-radio-group v-model="registerForm.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <div class="form-item">
            <el-form-item prop="name">
              <el-input v-model="registerForm.name" placeholder="請輸入姓名" />
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item prop="birthday">
              <el-date-picker v-model="registerForm.birthday" type="date" placeholder="選擇生日" style="width: 100%;" value-format="yyyy-MM-dd" />
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item prop="phone">
              <el-input v-model="registerForm.phone" placeholder="請輸入電話" />
            </el-form-item>
          </div>

          <div v-if="!hasRecommend">
            <div class="form-item">
              <el-form-item>
                <el-radio-group v-model="recommendType">
                  <el-radio label="account">推薦人帳號</el-radio>
                  <el-radio label="id">推薦人 ID</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="form-item">
              <el-form-item v-if="recommendType === 'account'" prop="recommendAccount">
                <el-input v-model="registerForm.recommendAccount" placeholder="請輸入推薦人帳號" />
              </el-form-item>
              <el-form-item v-else prop="recommendAccount">
                <el-input v-model="registerForm.recommendId" placeholder="請輸入推薦人 ID" />
              </el-form-item>
            </div>
          </div>
          <div v-else>
            <div class="form-item">
              推薦人帳號： {{ hiddenText(recommendName) }}
            </div>
          </div>
          <div class="form-item">
            <el-checkbox v-model="registerForm.check1">我已同意 <a href="https://www.hope-coop.org/privacy-policy" target="_blank">《隱私權政策》</a></el-checkbox>
          </div>
          <div class="form-item">
            <el-checkbox v-model="registerForm.check2">我已同意 <a href="https://www.hope-coop.org/regulation" target="_blank">《社員權利和義務》</a></el-checkbox>
          </div>
          <el-row type="flex" justify="end">
            <el-button native-type="submit" @click="handleRegister">
              送出
            </el-button>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import WelcomeImage from '@/assets/img/img_welcome.png'
import AccountImage from '@/assets/img/img_account.png'
import PasswordImage from '@/assets/img/img_password.png'

import api from '@/api'
import { mapActions } from 'vuex'
import { AccountTypeEnums, AccountTypeMap } from '@/utils/enum'

export default {
  components: {
    PageContainer
  },
  data() {
    return {
      WelcomeImage,
      AccountImage,
      PasswordImage,
      AccountTypeMap,
      recommendType: 'account',
      currentTab: 'login',
      tabs: [
        {
          key: 'login',
          text: '登入'
        }
        // ,
        // {
        //   key: 'register',
        //   text: '註冊'
        // }
      ],
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '請輸入帳號', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '請輸入密碼', trigger: 'blur' }
        ]
      },
      registerForm: {
        account: '',
        accountType: AccountTypeEnums.IDENTITY_CARD,
        registerPassword: '',
        repeatPassword: '',
        name: '',
        recommendAccount: '',
        recommendId: '',
        birthday: '',
        phone: '',
        sex: 1,
        check1: false,
        check2: false,
        check3: false
      },
      registerRules: {
        account: [
          { required: true, message: '請輸入帳號', trigger: 'blur' },
          { validator: this.ruleValidateID }
        ],
        registerPassword: [
          { required: true, message: '請輸入密碼', trigger: 'blur' },
          { validator: this.handleValidatePassword }
        ],
        repeatPassword: [
          { required: true, message: '請重複輸入帳號', trigger: 'blur' },
          { validator: this.handleValidateRepeatPassword }
        ],
        name: [
          { required: true, message: '請輸入姓名', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: '請輸入生日', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '請輸入手機', trigger: 'blur' }
        ],
        recommendAccount: [
          { required: true, message: '請輸入推薦人帳號', trigger: 'blur' }
        ]
      },
      hasRecommend: false
    }
  },
  computed: {
    recommendAccount() {
      return this.decodeBase64(this.$route.query.recommendAccount)
    },
    recommendName() {
      return this.decodeBase64(this.$route.query.recommendName)
    },
    accountTypeSelect() {
      return Object.keys(this.AccountTypeMap).map(item => ({
        value: item,
        label: this.AccountTypeMap[item]
      }))
    },
    accountTypes() {
      return Object.keys(this.AccountTypeMap)
    }
  },
  mounted() {
    const path = window.location.href
    if (path.includes('recommendAccount')) {
      this.registerForm.recommendAccount = this.recommendAccount
      this.currentTab = 'register'
      this.recommendType = 'account'
      this.hasRecommend = true
    }
  },
  methods: {
    ...mapActions(['setLoginStatus', 'setCookie', 'getUserInfo', 'getAddresses']),
    handleChangeTab(key) {
      this.currentTab = key
      const { loginForm, registerForm } = this.$refs
      loginForm && loginForm.resetFields()
      registerForm && registerForm.resetFields()
    },
    activeClass(key) {
      return key === this.currentTab ? 'auth__tab--active' : null
    },
    handleValidatePassword(rules, value, callback) {
      if (value.length < 8) {
        return callback('密碼至少 8 個字')
      }

      return callback()
    },
    handleValidateRepeatPassword(rules, value, callback) {
      if (value !== this.registerForm.registerPassword) {
        return callback('密碼不一致')
      }
      return callback()
    },
    async handleLogin() {
      const { account } = api
      this.$refs.loginForm.validate(async(error) => {
        if (!error) return
        const { data = {}} = await account.login(this.loginForm) || {}
        if (data.token) {
          this.setLoginStatus(true)
          this.setCookie(data.token)
          this.getUserInfo()
          this.getAddresses()
          this.$message({
            type: 'success',
            message: '登入成功',
            duration: 1500
          })
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        }
      })
    },
    handleRegister() {
      this.$refs.registerForm.validate(async(error) => {
        if (!error) return
        const params = {
          deptId: 1,
          roleId: 2,
          status: 1,
          ...this.registerForm,
          password: this.registerForm.registerPassword
        }
        delete params.registerPassword
        delete params.repeatPassword
        if (this.recommendType === 'account') {
          delete params.recommendId
        } else {
          delete params.recommendAccount
        }
        const { success } = await api.account.register(params) || {}
        if (success) {
          this.$message({
            type: 'success',
            message: '註冊成功，請登入',
            duration: 1500
          })
        }
      })
    },
    ruleValidateID(rules, value, callback) {
      const validates = [
        {
          ruleFunction: this.validateID,
          text: '請輸入正確的身分證'
        },
        {
          ruleFunction: this.validateUniformNumbers,
          text: '請輸入正確的統編'
        },
        {
          ruleFunction: this.validatePassport,
          text: '請輸入正確的護照'
        },
        {
          ruleFunction: this.validateChID,
          text: '請輸入正確的大陸身份證'
        },
        {
          ruleFunction: () => true
        }
      ]
      const accountTypeIndex = this.accountTypes.findIndex(item => item === this.registerForm.accountType)
      const { ruleFunction, text } = validates[accountTypeIndex]
      if (!ruleFunction(value)) {
        return callback(text)
      }
      return callback()
    },
    // 臺灣身份證
    validateID(value) {
      const tab = 'ABCDEFGHJKLMNPQRSTUVXYWZIO'
      const A1 = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3]
      const A2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5]
      const Mx = [9, 8, 7, 6, 5, 4, 3, 2, 1, 1]

      let i = tab.indexOf(value.charAt(0))

      if (i === -1) return false
      let sum = A1[i] + A2[i] * 9

      for (i = 1; i < 10; i++) {
        const v = parseInt(value.charAt(i))
        if (isNaN(v)) return false
        sum = sum + v * Mx[i]
      }
      return sum % 10 === 0
    },
    // 統一編號
    validateUniformNumbers(value) {
      const validateOperator = [1, 2, 1, 2, 1, 2, 4, 1]
      let sum = 0
      const calculate = function(product) {
        var ones = product % 10
        var tens = (product - ones) / 10
        return ones + tens
      }
      for (var i = 0; i < validateOperator.length; i++) {
        sum += calculate(value[i] * validateOperator[i])
      }
      return sum % 10 === 0 || (value[6] === '7' && (sum + 1) % 10 === 0)
    },
    // 臺灣護照
    validatePassport(value) {
      const reg = /^3\d{7}$/
      console.log()
      return reg.test(value)
    },
    // 大陸身份證
    validateChID(value) {
      const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/
      return reg.test(value)
    },
    handleReValidate() {
      this.$refs['registerForm'].validateField(['account'])
    },
    decodeBase64(base64) {
      return unescape(decodeURIComponent(window.atob(base64)))
    },
    hiddenText(text) {
      if (text.length === 2) {
        return `${text[0]}*`
      }
      return text.split('').reduce((acc, item, index) => {
        if (index === 0 || index === text.length - 1) {
          return acc + item
        }
        return acc + '*'
      }, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  @include minWidth992 {
    img {
      width: 75%;
    }
  }
}

.auth {
  &__tabs {
    display: flex;
    border: 1px solid $mainPurple;
    margin-bottom: 32px;
  }
  &__tab {
    flex: 1;
    border: 0;
    text-align: center;
    padding: 12px 0;
    background-color: transparent;
    color: #000;
    font-size: 16px;
    cursor: pointer;
    &--active {
      background-color: $mainPurple;
      color: #fff;
    }
  }
}

.form-item {
  display: flex;
  .el-form-item {
    flex: 1;
  }
  ::v-deep.el-input__inner {
    border-radius: 0;
    border: 1px solid $mainPurple;
    position: relative;
  }
  ::v-deep.el-form-item.is-error .el-input__inner {
    border-color: #F56C6C;
  }
  &__icon {
    padding: 8px;
    width: 40px;
    height: 40px;
    border: 1px solid $mainPurple;
    border-right: 0;
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
    }
  }
  > p {
    line-height: 40px;
    margin-right: 12px;
  }
  ::v-deep.el-radio__input.is-checked .el-radio__inner, ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: $mainPurple;
    background-color:  $mainPurple;
  }
  ::v-deep.el-radio__input.is-checked+.el-radio__label, ::v-deep.el-checkbox__input.is-checked+.el-checkbox__label {
    color: $mainPurple;
  }
}

.el-button {
  background-color: #264682;
  color: #fff;
  border: 0;
  width: 100%;
  max-width:120px;

  &:hover {
    background-color:  #6AF3EA;
  }
}

</style>
